import { createContext, useContext } from 'react';

import type { CurrentUser } from './auth';

export const SessionContext = createContext<CurrentUser | null>(null);

export function useSessionUser(): CurrentUser {
  const user = useContext(SessionContext);
  if (!user) {
    throw new Error('useSessionUser must be used inside <SessionContext.Provider>');
  }
  return user;
}
